import React from "react";
import {QuestionsFullRender} from "../../../modules/QuestionsFullRender";

export default function QuestionsRenderPage() {

    return (
        <QuestionsFullRender />
    )
}